//#region imports
import { SignatureService } from 'src/app/services/signature.service';
import { SaveService } from 'src/app/services/save.service';
import { DigitalSignatureService } from './../../../../services/digital-signature.service';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { exportFile } from 'src/app/shared/utils/export-file.function';
import { DocumentService } from 'src/app/services/document.service';
import { openFile } from 'src/app/shared/utils/open-file.function';
import { Documents } from 'src/app/shared/model/document.model';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { Globals } from 'src/app/services/globals';
import { base64ToArrayBuffer } from 'src/app/shared/utils/base64-arraybuffer.function';
import { TranslateService } from '@ngx-translate/core';
//#endregion

@Component({
  selector: 'app-signature-question6',
  templateUrl: './signature-question6.component.html',
  styleUrls: ['./signature-question6.component.css']
})
export class SignatureQuestion6Component implements OnInit, OnDestroy {
  //#region variables
  public percentage: number;
  public errorSignedDoc = '';
  public errorIdDoc = '';
  public singnedDocName = 'No File Selected';
  public idDocName = 'No File Selected';
  fileType: string;
  //#endregion


  //#region methods
  constructor(
    private digitalSignature: DigitalSignatureService,
    private documentService: DocumentService,
    private saveService: SaveService,
    private globals: Globals,
    private signatureService: SignatureService,
    private characteristicService: CharacteristicService,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    if (!!this.signatureService.SaveDocuments) {
      this.singnedDocName = this.signatureService.SaveDocuments.SignedDocFileName;
      this.idDocName = this.signatureService.SaveDocuments.IdDocFileName;
    }
    this.signatureService.getPercentage().subscribe((data) => {
      this.percentage = data;
      if (this.percentage !== 75) {
        this.signatureService.setDisableSignatureNext(true);
      } else {
        //this.signatureService.setDisableSignatureNext(false);
        this.signatureService.setDisableSignatureNext(true);
      }
    });
  }

  openPdf() {
    if (!!this.documentService.pdfDocument && this.documentService.pdfDocument.length > 0) {
      openFile(this.documentService.pdfDocument, 'application/pdf');
    }
  }

  downloadPdf() {
    if (!!this.documentService.pdfDocument && this.documentService.pdfDocument.length > 0) {
      exportFile(this.documentService.pdfDocument, 'application/octet-stream', 'Project_' + this.documentService.fniceNo, 'pdf');
      if (this.percentage === 0) {
        this.signatureService.setPercentage(25);
      }
    }
  }


  signedDocSelected($event) {
    this.errorSignedDoc = '';
    const files = $event.target.files;
    const fileType = files[0].type;
    if (fileType === 'application/pdf') {
      this.singnedDocName = files[0].name;
      const reader = new FileReader();
      if (files[0].size > 5242880) {
        this.errorSignedDoc = 'File_Upload_Max5MB'; //'File size should be less than 5MB';
        return;
      }
      reader.readAsDataURL(files[0]);
      const contactDetails = this.saveService.getContactDetails();
      reader.onload = () => {
        this.signatureService.SaveDocuments = {} as Documents;
        this.signatureService.SaveDocuments.SimulationToken = this.saveService.getSimulationToken();
        this.signatureService.SaveDocuments.FniceNo = this.documentService.fniceNo;
        this.signatureService.SaveDocuments.SignedDocFileAsBase64 = reader.result as string;
        this.signatureService.SaveDocuments.SignedDocFileName = this.singnedDocName;
        this.signatureService.SaveDocuments.Email = contactDetails.EmailAddress;
        this.signatureService.SaveDocuments.Firstname = contactDetails.EmailAddress;
        this.signatureService.SaveDocuments.Lastname = contactDetails.EmailAddress;
        this.signatureService.SaveDocuments.Language = this.globals.languagecode.toUpperCase();

        if (this.percentage === 25) {
          this.signatureService.setPercentage(50);
        } else if (this.percentage === 50) {
          this.signatureService.setPercentage(75);
        }
      };
    } else {
      this.errorSignedDoc = 'File_Upload_PDFOnly'; //'Only PDF Format is allowed';
      if (this.percentage === 50) {
        this.signatureService.setPercentage(25);
      }
      if (this.percentage === 75) {
        this.signatureService.setPercentage(50);
      }
    }
  }

  idDocSelected($event) {
    this.errorIdDoc = '';
    const files1 = $event.target.files;
    this.fileType = files1[0].type;
    if (this.fileType === 'application/pdf' || this.fileType.includes('image/')) {
      this.idDocName = files1[0].name;
      if (files1[0].size > 5242880) {
        this.errorIdDoc = 'File_Upload_Max5MB'; //'File size should be less than 5MB';
        if (this.percentage === 75) {
          this.signatureService.setPercentage(50);
        } 
        return;
      }
      const extension = files1[0].name.split('.').pop();
      const reader1 = new FileReader();
      reader1.readAsDataURL(files1[0]);

      reader1.onload = () => {
        this.signatureService.SaveDocuments.IdDocFileAsBase64 = reader1.result as string,
          this.signatureService.SaveDocuments.IdDocExtension = extension,
          this.signatureService.SaveDocuments.IdDocFileName = this.idDocName;
        this.signatureService.setPercentage(75);
      };
    } else {
      this.errorIdDoc = 'File_Upload_PDFIMGOnly'; //'Only PDF and Image Formats are allowed';
      if (this.percentage === 75) {
        this.signatureService.setPercentage(50);
      } 
      // else if (this.percentage === 50) {
      //   this.signatureService.setPercentage(25);
      // }
    }
  }

  validateSignature() {
    const contactDetails = this.saveService.getContactDetails();
    this.globals.trackPageActivity += ';' + 'UPLOAD0';
      const saveRequestSave = {
        firstName: contactDetails.FirstName, lastName: contactDetails.LastName,
        email: contactDetails.EmailAddress, phone: contactDetails.Telephone, code: contactDetails.PostalCode
      };
      this.saveService.setIsProjectCompleted(true)
      this.globals.sendSimulationMail = false;
      this.saveService.saveSimulation(saveRequestSave, 'Save').subscribe((data) => {
        this.saveService.setSimulationToken(data.Tocken);
        this.saveService.setProspectNumber(data.CRMProspect);
        this.saveService.setShortToken(data.shortTocken);
      });
    const saveRequest = {
      SimulationToken: this.saveService.getSimulationToken(),
      FniceNo: this.documentService.fniceNo,
      EMail: this.signatureService.saveAddress.Simulation_mail_Contact, // contactDetails.EmailAddress,
      FirstName: contactDetails.FirstName,
      Language: this.globals.languagecode,
      LastName: contactDetails.LastName,
      Base64File: this.documentService.pdfDocument,
      PhoneNumber: this.signatureService.saveAddress.Simulation_Phone_Contact //contactDetails.Telephone
    };
    this.digitalSignature.validateDigitalSignature(saveRequest).subscribe((response) => {
      // console.log('data');
      this.document.location.href = response;
    }, (error) => {
      const input = {
        title: this.translate.instant('Msg_Error_Title'), 
        errorMessage: this.translate.instant('Msg_Service_Error'),
        disableClose: false};
      this.characteristicService.serverFailError(input);
    });
  }

  ngOnDestroy(): void {
    // this.sisgnatureService.setDisableSignatureNext(true);
  }

finaliseManualSignature(){
  this.saveService.setIsProjectCompleted(true);
  this.globals.trackPageActivity += ';' + 'UPLOAD1, UPLOAD2, UPLOAD3';
  this.signatureService.saveSignedDocument().subscribe((value) => {
    if (value) {
      const contactDetails = this.saveService.getContactDetails();
      const saveRequest = {
        firstName: contactDetails.FirstName, lastName: contactDetails.LastName,
        email: contactDetails.EmailAddress, phone: contactDetails.Telephone, code: contactDetails.PostalCode
      };
      this.saveService.setIsProjectCompleted(true);
      this.saveService.setSimulationStatus('Project Signed');
      this.saveService.setProjectStatus('Project Signed');
      this.globals.sendSimulationMail = false;
      this.saveService.saveSimulation(saveRequest, 'Save').subscribe((data) => {
        this.saveService.setSimulationToken(data.Tocken);
        this.saveService.setProspectNumber(data.CRMProspect);
        this.saveService.setShortToken(data.shortTocken);
        this.signatureService.setShowSignaturePrevious(true);
        this.signatureService.setShowSignatureNext(false);
        this.signatureService.setSignatureCurrentPage(false, false, false, false, false, false, true, false);
      });
    }
  }, (error) => {
    const input = {
      title: this.translate.instant('Msg_Error_Title'), 
      errorMessage: this.translate.instant('Msg_Service_Error'), 
      disableClose: false};
    this.characteristicService.serverFailError(input);
  });

}
  //#endregion
}
